import React, { Component } from 'react';
import { Field, reduxForm, formValueSelector, initialize, change } from 'redux-form';
import { connect } from 'react-redux';

import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl } from 'react-intl';
import cx from 'classnames';
import {
	Form,
	Col,
	Row,
} from 'react-bootstrap';


import Link from '../../../Link';
import Loader from '../../../Common/Loader';
import SelectFieldComponent from '../../../Common/SelectFieldComponent/SelectFieldComponent';
import InputFieldComponent from '../../../Common/InputFieldComponent/InputFieldComponent';

import messages from '../../../../locale/messages';
import validate from './validate';
import submit from './submit';

import bt from '../../../../components/commonStyle.css';
import s from './PricingForm.css';
import st from './PricingStudioForm.css';


export class PricingForm extends Component {
	static defaultProps = {
		currency: 'USD',
		loading: false
	};

	constructor(props) {
		super(props);
		this.handlePriceType = this.handlePriceType.bind(this);
	}

	componentDidUpdate() {
		const { categoryId, categories, change } = this.props;
		categories && categories.getActiveCategories && categories.getActiveCategories.results
			&& categories.getActiveCategories.results.map(category => ((category.id == categoryId) && change('pricingType', category.pricingType)
			))
	}

	async handlePriceType(e) {
		const { categories, change } = this.props;
		categories && categories.getActiveCategories && categories.getActiveCategories.results
			&& categories.getActiveCategories.results.map(category => ((category.id == e) && change('pricingType', category.pricingType)
			))
	}


	render() {
		const { handleSubmit, currency, loading, submitting, id, locations, categories, subCategories, categoryId, pricingType, basePrice, multiplierValue, currencyValue, subCategoryId, locationId, isPriceEditable } = this.props;
		const { formatMessage } = this.props.intl;
		const locationfilter = locations && locations?.getAllLocation && locations?.getAllLocation?.results
			&& locations.getAllLocation.results.filter((location) => location.isActive)
		const locationOptions = [{ value: '', label: formatMessage(messages.locationName) }]
		const locationFormatted = locationfilter && locationfilter?.map((location) => {
			return {
				value: location?.id,
				label: location?.locationName
			}
		}) || []

		locationOptions.push(...locationFormatted);

		const categoryOptions = [{ value: "", label: formatMessage(messages.category) }]
		const categoryOptionsFormatted = categories && categories?.getActiveCategories && categories?.getActiveCategories?.results
			&& categories.getActiveCategories?.results?.map(category => {
				return {
					value: category?.id,
					label: category?.name
				}
			})
		categoryOptionsFormatted && categoryOptions.push(...categoryOptionsFormatted);

		const subCategoryFilter = subCategories && subCategories.getActiveSubCategories && subCategories.getActiveSubCategories.results
			&& subCategories.getActiveSubCategories.results.filter(subCategory => (subCategory.categoryId == categoryId))
		const subCategoryOptions = [{ value: "", label: formatMessage(messages.subCategory) }]
		const subCategoryFormatted = subCategoryFilter && subCategoryFilter.map((subCategory) => {
			return {
				value: subCategory?.id,
				label: subCategory?.name
			}
		}) || []
		subCategoryOptions.push(...subCategoryFormatted)

		const isActiveOptions = [
			{ value: true, label: formatMessage(messages.active) },
			{ value: false, label: formatMessage(messages.inactive) }
		]

		const currencyOptions = currency && currency.availableCurrencies && currency.availableCurrencies?.filter(item => item?.isEnable)?.map(currency => {
			return {
				value: currency?.symbol,
				label: currency?.symbol
			}
		})
		const priceEditableOptions = [
			{ value: false, label: formatMessage(messages.no) },
			{ value: true, label: formatMessage(messages.yes) }
		]

		// Live preview helpers
		const findLabel = (opts, val) => (opts.find(o => String(o.value) === String(val)) || {}).label;
		const previewCat = findLabel(categoryOptions, categoryId);
		const previewSub = findLabel(subCategoryOptions, subCategoryId);
		const previewLoc = findLabel(locationOptions, locationId);
		const previewUnit = pricingType === 'fixed'
			? `· max qty ${multiplierValue || 0}`
			: `/hr · min ${multiplierValue || 0}h`;
		const isEditable = isPriceEditable === true || isPriceEditable === 'true';

		return (
			<Form className={s.fullWidth} onSubmit={handleSubmit(submit)} >
				<h1 className='siteAdminPrimaryHeading'>{id ? formatMessage(messages.editFare) : formatMessage(messages.addFare)}</h1>
				<div className={st.layout}>
				<div className={st.card}>
				<div className='threeColumnGrid'>
					<Field
						name="locationId"
						placeholder={formatMessage(messages.locationName)}
						component={SelectFieldComponent}
						label={formatMessage(messages.locationName)}
						options={locationOptions}
						inputClass={bt.formControlSelect}
						showToolTip
						toolTipText={formatMessage(messages.manageFareLocationTooltip)}
						isBottom={true}
					/>

					<Field
						name="categoryId"
						placeholder={formatMessage(messages.category)}
						component={SelectFieldComponent}
						options={categoryOptions}
						label={formatMessage(messages.category)}
						inputClass={bt.formControlSelect}
						onChange={(e) => { this.handlePriceType(e && e.target.value) }}
						showToolTip
						toolTipText={formatMessage(messages.manageFareCategoryTooltip)}
						isBottom={true}
					/>

					<Field
						name="subCategoryId"
						placeholder={formatMessage(messages.subCategory)}
						component={SelectFieldComponent}
						options={subCategoryOptions}
						label={formatMessage(messages.subCategory)}
						inputClass={bt.formControlSelect}
						showToolTip
						toolTipText={formatMessage(messages.manageFareSubCategoryTooltip)}
						isBottom={true}
					/>

					<Field
						name="isActive"
						label={formatMessage(messages.status)}
						options={isActiveOptions}
						component={SelectFieldComponent}
						showToolTip
						inputClass={bt.formControlSelect}
						toolTipText={formatMessage(messages.manageFareStatusTooltip)}
					/>

					<Field
						name="currency"
						label={formatMessage(messages.currency)}
						showToolTip
						toolTipText={formatMessage(messages.manageFareCurrencyTooltip)}
						component={SelectFieldComponent}
						options={currencyOptions}
						inputClass={bt.formControlSelect}
					/>

					<Field name="isPriceEditable"
						inputClass={bt.formControlSelect}
						component={SelectFieldComponent}
						options={priceEditableOptions}
						label={formatMessage(messages.isPriceEditable)}
						showToolTip
						toolTipText={formatMessage(messages.manageFareEditableServiceProviderTooltip)}
					/>

					<Field
						name="basePrice"
						type="text"
						placeholder={pricingType == 'fixed' ? formatMessage(messages.basePrice) : formatMessage(messages.hourlyPrice)}
						component={InputFieldComponent}
						label={pricingType == 'fixed' ? formatMessage(messages.basePrice) : formatMessage(messages.hourlyPrice)}
						inputClass={bt.formControlInput}
						maxLength={6}
						showToolTip={pricingType == 'fixed'}
						toolTipText={pricingType == 'fixed' ? formatMessage(messages.manageFareBaseTooltip) : false}
					/>

					<Field
						name="multiplierValue"
						type="text"
						placeholder={pricingType == 'fixed' ? formatMessage(messages.maxQuantity) : formatMessage(messages.minHours)}
						component={InputFieldComponent}
						label={pricingType == 'fixed' ? formatMessage(messages.maxQuantity) : formatMessage(messages.minHours)}
						inputClass={bt.formControlInput}
						maxLength={6}
						showToolTip={pricingType == 'fixed'}
						toolTipText={pricingType == 'fixed' ? formatMessage(messages.manageFareMaximumQuantityTooltip) : false}
					/>
				</div>
				</div>

				<div className={st.preview}>
					<div className={st.previewTitle}>Fare preview</div>
					<div className={st.fareCard}>
						<div className={st.price}>{currencyValue || ''} {basePrice || 0}</div>
						<div className={st.priceUnit}>{previewUnit}</div>
						<div className={st.rows}>
							<div className={st.lineLabel}>{formatMessage(messages.category)}</div>
							<div className={st.lineValue}>{previewCat || '—'}</div>
							<div className={st.lineLabel}>{formatMessage(messages.subCategory)}</div>
							<div className={st.lineValue}>{previewSub || '—'}</div>
							<div className={st.lineLabel}>{formatMessage(messages.locationName)}</div>
							<div className={st.lineValue}>{previewLoc || '—'}</div>
							{isEditable && <span className={st.editable}>Pro can edit</span>}
						</div>
					</div>
				</div>
				</div>

				<div className='commonButtonContainer'>
					<Link to={"/siteadmin/pricing/list"} className={bt.btnSecondary} >{formatMessage(messages.goBack)}</Link>
					<Loader
						type={"button"}
						label={formatMessage(messages.submitButton)}
						show={loading}
						buttonType={'submit'}
						className={cx(bt.btnPrimary, 'loaderButtonFlex')}
						disabled={submitting || loading}
					/>
				</div>
			</Form>
		)
	}
}
PricingForm = reduxForm({
	form: 'PricingForm',
	onSubmit: submit,
	validate
})(PricingForm);
const selector = formValueSelector('PricingForm');
const mapState = (state) => ({
	currency: state.currency,
	loading: state.loader.PricingForm,
	categoryId: selector(state, 'categoryId'),
	pricingType: selector(state, 'pricingType'),
	basePrice: selector(state, 'basePrice'),
	multiplierValue: selector(state, 'multiplierValue'),
	currencyValue: selector(state, 'currency'),
	subCategoryId: selector(state, 'subCategoryId'),
	locationId: selector(state, 'locationId'),
	isPriceEditable: selector(state, 'isPriceEditable'),
})
const mapDispatch = {
	initialize,
	change
}
export default injectIntl(withStyles(bt, s, st)(connect(mapState, mapDispatch)(PricingForm)));
